module.exports = __webpack_public_path__ + "img/entryway-ottomans-poufs.24140d1.jpg";